import { Home } from "./components/Home";
import { CoffeeMenu } from "./components/CoffeeMenu";
import { Login } from "./components/Login";
import { Register } from "./components/Register";
import { ServicePage } from "./components/ServicePage";
import { Settings } from "./components/Settings";
import { AdminPage } from "./components/AdminPage";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/order',
    element: <CoffeeMenu />
  },
  {
    path: '/service',
    element: <ServicePage />
  },
  {
    path: '/settings',
    element: <Settings />
  },
  {
    path: '/admin',
    element: <AdminPage />
  }
];

export default AppRoutes;
